import { useLocation } from "react-router";
import { FC, PropsWithChildren, useEffect } from "react";

const ScrollToTop: FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return children;
};

export default ScrollToTop;
